import { memo, useState } from 'react';

import { useCurrentUserClientTimezone } from '../../../contexts/OidcContext/OidcContext.selectors';
import { useInterval } from '../../../hooks/useInterval';
import { StyledTimeContainer } from './Clock.style';
import { TimeDisplay } from './TimeDisplays/TimeDisplay';

export const Clock = memo(function Clock({ onClickCallback }: { onClickCallback?: () => void }) {
    const timezone = useCurrentUserClientTimezone();

    const [time, setTime] = useState(Date.now());
    useInterval(() => setTime(Date.now()), 60000);

    return (
        <StyledTimeContainer onClick={onClickCallback}>
            <TimeDisplay time={time} blink={true} timezone={timezone} />
        </StyledTimeContainer>
    );
});
